import { render, staticRenderFns } from "./CollectionDeleteModal.vue?vue&type=template&id=55d4cfba"
import script from "./CollectionDeleteModal.vue?vue&type=script&lang=ts"
export * from "./CollectionDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports